<form class="form-inline" (ngSubmit)="go()">
  <h3-button
    [disable]="(positionStore.$ | async) === 1"
    extraClasses="btn-sm"
    (h3Click)="previous()"
  >
    <span class="glyphicon glyphicon-arrow-left"></span> Previous
  </h3-button>
  &emsp;
  <div class="input-group position-input-group">
    <input
      class="input-sm form-control position-input"
      name="position"
      [max]="taskCount$ | async"
      min="1"
      [nasModel]="positionStore"
      type="number"
    />
    <span class="input-group-addon">of {{ taskCount$ | async }}</span>
  </div>
  <h3-button (h3Click)="go()" extraClasses="btn-sm">Go</h3-button>
  &emsp;
  <h3-button
    [disable]="(positionStore.$ | async) === (taskCount$ | async)"
    extraClasses="btn-sm"
    (h3Click)="next()"
  >
    Next <span class="glyphicon glyphicon-arrow-right"></span>
  </h3-button>
</form>
